import { z } from "zod";

export const ContactDTO = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  phone: z.string(),
});

export type Contact = z.infer<typeof ContactDTO>;
